import queryKeys from '@/constants/queryKeys';
import { userNotificationPreferencesGet } from '@/services/api/requests/user';
import { useQuery } from '@tanstack/react-query';

const useNotificationPreferences = () => {
  const { isLoading, data, isError, error, isRefetching, refetch } = useQuery({
    queryKey: [queryKeys.user.notificationPreferences],
    queryFn: async () => {
      const response = await userNotificationPreferencesGet();

      return response;
    },
  });

  return { isLoading, data, isError, error, isRefetching, refetch };
};

export { useNotificationPreferences };
